import { Container, Row, Col, Card, Button, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faCommentDots } from "@fortawesome/free-solid-svg-icons";
import Broker1 from "../Images/rianbotes.png";
import Broker2 from "../Images/CharlesSkinner.png";
import Broker3 from "../Images/InaLeRoux.jpeg";
import { TelephoneFill } from "react-bootstrap-icons";

const brokers = [
    {
        name: "Rian Botes",
        title: "Personal, Business Insurance & Special Risk",
        phone: "082 880 4219",
        email: "info@logosbrokers.co.za",
        img: Broker1,
        whatsapp: "828804219"
    },
    {
        name: "Charles Skinner",
        title: "Medical Malpractice",
        phone: "082 338 3950",
        email: "info@logosbrokers.co.za",
        img: Broker2,
        whatsapp: "738784875"
    },
    {
        name: "Ina le Roux",
        title: "Medical Malpractice, Medical Aid, Gap Cover, Health Insurance",
        phone: "071 182 8492",
        email: "admin@logosbrokers.co.za",
        img: Broker3,
        whatsapp: "711828492"
    }
];

export const ContactUs = () => {
    return (
        <Container fluid style={{ backgroundColor: "#f9f9fb", padding: "4rem 2rem" }}>
            <h1 style={{ textAlign: "center", color: "#1e1e3f", fontWeight: "700", marginBottom: "2rem" }}>
                Contact Us
            </h1>
            <Container style={{ maxWidth: "900px" }}>
                <div style={{ textAlign: "center", marginBottom: "3rem" }}>
                    <p style={{ fontSize: "1.2rem", color: "#333" }}>
                        We're here to help you find the right cover. Reach out to our team of experts.
                    </p>
                    <p style={{ fontSize: "1.1rem", color: "#1e1e3f", fontWeight: "500" }}>
                        <FontAwesomeIcon icon={faEnvelope} /> info@logosbrokers.co.za &nbsp; | &nbsp;
                        <FontAwesomeIcon icon={faPhone} /> 073 878 4875 &nbsp; | &nbsp;
                        <FontAwesomeIcon icon={faCommentDots} /> <a href="https://wa.me/738784875" style={{ color: "#1e1e3f", textDecoration: "underline" }}>WhatsApp Us</a>
                    </p>
                </div>
                <Container className="my-4">
                    <Alert
                        variant="danger"
                        style={{
                            backgroundColor: "#f8d7da",
                            borderColor: "#f5c6cb",
                            color: "#721c24",
                            borderRadius: "10px",
                            padding: "1.25rem 1.5rem",
                            display: "flex",
                            alignItems: "center",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                        }}
                    >
                        <TelephoneFill size={24} className="me-3" />
                        <div>
                            <strong>For emergencies, please call:</strong><br />
                            <span style={{ fontSize: "1.15rem" }}>082 880 4219</span>
                        </div>
                    </Alert>
                </Container>
                <Row className="justify-content-center">
                    {brokers.map((broker, idx) => (
                        <Col md={6} lg={4} key={idx} className="mb-4 d-flex">                            <Card
                            className="h-100 w-100"
                            style={{
                                borderRadius: "15px",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                                padding: "1.5rem",
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-5px)";
                                e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.2)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
                            }}
                        >
                            <div className="d-flex flex-column justify-content-between h-100">
                                <div>
                                    <div
                                        style={{
                                            width: "90px",
                                            height: "90px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            margin: "0 auto 1rem",
                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        <img
                                            src={broker.img}
                                            alt={broker.name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                    <h5 style={{ fontWeight: "600", color: "#1e1e3f" }}>{broker.name}</h5>
                                    <div style={{ fontSize: "0.95rem", color: "#555", marginBottom: "0.5rem" }}>
                                        {broker.title.split(/,|&/).map((line, i) => (
                                            <div key={i}>{line.trim()}</div>
                                        ))}
                                    </div>                                        <p style={{ fontSize: "0.9rem", color: "#1e1e3f", marginBottom: "0.25rem" }}>
                                        <FontAwesomeIcon icon={faPhone} /> {broker.phone}
                                    </p>
                                    <p style={{ fontSize: "0.9rem", color: "#1e1e3f" }}>
                                        <FontAwesomeIcon icon={faEnvelope} /> {broker.email}
                                    </p>
                                </div>
                                <Button
                                    href={`https://wa.me/` + broker.whatsapp}
                                    variant="outline-primary"
                                    style={{ marginTop: "1rem", borderRadius: "25px", fontSize: "0.9rem" }}
                                >
                                    WhatsApp Agent
                                </Button>
                            </div>
                        </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
};
